import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopRoutingLocationRuleDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateRoutingLocationRules(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("patch", "/shops/{shopId}/routing-location-rules");
  const invalidateShop = useInvalidateShop(shopId);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (requestBody: ShopRoutingLocationRuleDto[]) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: requestBody,
      });
    },
  });
}
